import React from 'react';
import streamsPng from '../../assets/streams.png';

type StreamsGlyphProps = {
  className?: string;
  size?: number; // optional pixel size override
};

export const StreamsGlyph: React.FC<StreamsGlyphProps> = ({ className, size }) => {
  const dimensionStyle = size ? { width: size, height: size } : undefined;
  return (
    <span
      className={className}
      style={{
        ...dimensionStyle,
        display: 'inline-block',
        backgroundColor: 'currentColor',
        WebkitMaskImage: `url(${streamsPng})`,
        maskImage: `url(${streamsPng})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
      aria-hidden="true"
    />
  );
};

export default StreamsGlyph;


